export class 取込履歴型 {
  public 取込ファイル番号: number;
  public 取込日時: Date;
  public ファイル名: string;
  public 取込状態: string;

  constructor(取込ファイル番号: number, 取込日時: Date, ファイル名: string, 取込状態: string) {
    this.取込ファイル番号 = 取込ファイル番号;
    this.取込日時 = 取込日時;
    this.ファイル名 = ファイル名;
    this.取込状態 = 取込状態;
  }
}

